module.exports = __webpack_public_path__ + "static/media/Typical Fancy Yarns1.0bae8e8b.jpg";